/*
 * 文件EN: merchantAudit.js,
 * 文件CN: 商户系统审核,
 * 创建时间: Wednesday, 29th April 2020 5:45:42 pm,
 * 创建人: CP-Mac,
 * 联系邮箱: you@you.you,
 */
import request from '@/plugins/http'
import qs from 'qs'

// 列表获取
export const getListData = params => {
  return request.get('/merSysReview/query/list', params)
}

// 转移发行/批量
export const transferIssueBatch = params => {
  return request.post('/merSysReview/transferIssueBatch', params, { json: true })
}

/**
 * @desc 上送审核 单个
 * @method POST
 * @param { merId: 商户/供应商id }
    */
export const confirm = params => {
  return request.post('/merSysReview/confirm', qs.stringify(params))
}

/**
 * @desc 上送审核 批量
 * @method POST
 * @param { merIds: 商户/供应商id [] }
    */
export const confirmArr = data => {
  return request.post('/merSysReview/transferChannelBatch', qs.stringify(data))
}

/**
 * @desc 经营状况总结
 * @method GET
 * @param { merNo: 商户/供应商id }
    */
export const fetchManagementForms = params => {
  return request.get('/manualReview/managementForms', params)
}

// 第三方支付交易数据
export const thirdPayData = params => {
  return request.get('/manualReview/thirdPayData', params)
}
// 第三方支付数据统计
export const thirdPayStatistics = params => {
  return request.get('/manualReview/thirdPayStatistics', params)
}
// 第三方交易整体占比图
export const thirdPaymentFigure = params => {
  return request.get('/manualReview/thirdPaymentFigure', params)
}

// 外卖数据统计
export const takeAwayStatistics = params => {
  return request.get('/manualReview/takeAwayStatistics', params)
}

// 外卖数据核定
export const takeAwayDataApproval = params => {
  return request.get('/manualReview/takeAwayDataApproval', params)
}

// 支出
export const disburse = params => {
  return request.get('/manualReview/disburse', params)
}

/**
 * @desc 审核报告
 * @method GET
 * @param { merNo: merNo }
*/
export const fetchAuditReport = params => {
  return request.get('/manualReview/auditReport', params)
}


/**
 * @desc 新审核报告
 * @method post
*/
export const getResult = data => {
  return request.post('/bairong/riskControl/getResult', qs.stringify(data))
}

// 特殊名单验证
export const getFlagSpecialList = data => {
  return request.post('/bairong/riskControl/getFlagSpecialList', qs.stringify(data))
}
// 借贷行为验证
export const getTotalLoan = data => {
  return request.post('/bairong/riskControl/getTotalLoan', qs.stringify(data))
}

export const getTotalLoanIdAndCell = data => {
  return request.post('/bairong/riskControl/getTotalLoanIdAndCell', qs.stringify(data))
}


export const getInfoRelation = data => {
  return request.post('/bairong/riskControl/getInfoRelation', qs.stringify(data))
}

/**
 * @desc 审核报告导出
 * @method GET
 * @param { merNo: merNo }
*/
export const fetchAuditReportExport = params => {
  return request.get('/manualReview/auditReporttExport', params)
}
/**
 * @desc 审核报告修改
 * @param {*} params 
 * @returns 
 */
export const auditReportUpdate = data => {
  return request.post('/manualReview/auditReportUpdate', data, { json: true })
}

/**
 * @desc 负责人信息
 * @method GET
 * @param { merNo: merNo }
*/
export const fetchPrincipalInfo = params => {
  return request.get('/manualReview/principalInfo', params)
}

// 关系验证列表信息
export const getRelationship = params => {
  return request.get('/manualReview/relationshipVerify', params)
}

// 允许发送-是 查看建议额度
export const getViewAllowSend = params => {
  return request.get('/merSysReview/viewAllowSend', params)
}

// 允许发送-是 修改建议额度
export const sendAllowSend = data => {
  return request.post('/merSysReview/allowSend', qs.stringify(data))
}

// 商户系统审核 - 无额度通过转为有额度通过
export const sendWithQuota = data => {
  return request.post('/merSysReview/sendWithQuota', qs.stringify(data))
}

// 批量导出商户详情列表到EXCEL - 内容+图片
export const getExport = data => {
  return request.get('/merSysReview/detail/export', qs.stringify(data))
}

// 关系验证-相关联系人列表
export const listContacts = data => {
  return request.get('/merSysReview/listContacts', qs.stringify(data))
}

// 关系验证-相关法人列表
export const listRelationCorps = data => {
  return request.get('/merSysReview/listRelationCorps', qs.stringify(data))
}

// 关系验证-相关地理信息列表
export const listRelationGeographicInfo = data => {
  return request.get('/merSysReview/listRelationGeographicInfo', qs.stringify(data))
}

// 关系验证-用户匹配信息列表
export const listUserMatchingInfor = data => {
  return request.get('/merchant/entry/selectNearMerAndSup', qs.stringify(data))
}

 // 关联分析-获取工商详细信息
export const getBusinessDetailsInfo = data => {
  return request.get('/merSysReview/getBusinessDetailsInfo', qs.stringify(data))
}

 // 关联分析-获取疑似关联信息
 export const getSuspectedAssociationInfo = data => {
  return request.get('/merSysReview/getSuspectedAssociationInfo', qs.stringify(data))
}
